module.exports = __webpack_public_path__ + "a770b6797b68e3f8920e473eb824bac0.gif";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/img/loader-big.gif
// module id = 1769
// module chunks = 0